// extracted by mini-css-extract-plugin
export default {"badge":"live-score-badge_badge__llc4a","win":"live-score-badge_win__+LqdX","draw":"live-score-badge_draw__4+G95","lose":"live-score-badge_lose__Qc10u"};